import { ContentDto } from '@portals/shared/portal/ContentDto';
import type { teamPageSchema } from '@portals/shared/portal/TeamPageDto';
import type { z } from 'zod';

import { request } from '@/request';

/**
 * Mirrors the server schema, which deliberately omits path/parent/teamId/teams — the server
 * derives those from the team's content prefix and the parent page.
 */
type InputData = z.input<typeof teamPageSchema>;

export async function createOrUpdatePage(teamId: string, content: InputData): Promise<ContentDto> {
  return request(`/team/${teamId}/team-pages`, 'put', content);
}

export async function deletePage(teamId: string, pageId: string): Promise<void> {
  return request(`/team/${teamId}/team-pages/${pageId}`, 'delete');
}
